import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import { useRecurly } from '@recurly/react-recurly';
import { useAppSelector } from '../../../hooks/useAppSelector';
import { configSelector } from '../../../redux/ConfigState/ConfigState.selectors';
import { ElementType, sendRioEvent, SpecType, SubType, PaymentMethodsCommandNames, StatusTypes, VendorType } from '@chegg/commerce-utils';
import { getString } from '../../../constants/Strings';
import { doFireStatusUpdate, sendRioEventCallback } from '../../../utils/CallbackUtils';
import { Component } from '../../../constants/CallbackConstants';
import { sendNewRelicMessage } from '../../../utils/NewRelicUtils';
import { useDispatch } from 'react-redux';
import { createMOPError } from '../../../redux/PaymentState/PaymentState.actions';
import { mopGeneric } from '../../../constants/PaymentTypes';
import { ERRORS } from '../../../constants/Errors';
import { MERCHANT_COUNTRY } from '../../../constants/AppConstants';
import { useHandlePaymentAuthorized } from './recurlyServiceHelpers';
export var useApplePay = function useApplePay() {
  var applePayButtonId = 'my-apple-pay-button';
  var _useAppSelector = useAppSelector(configSelector),
    appConstants = _useAppSelector.appConstants,
    rioNamespace = _useAppSelector.rioNamespace,
    country = _useAppSelector.country,
    priceSummary = _useAppSelector.priceSummary,
    _useAppSelector$isPri = _useAppSelector.isPrimary,
    isPrimary = _useAppSelector$isPri === void 0 ? true : _useAppSelector$isPri;
  var _ref = appConstants,
    clientAuthorization = _ref.recurly.braintreeToken;
  var recurly = useRecurly();
  var dispatch = useDispatch();
  var handlePaymentAuthorized = useHandlePaymentAuthorized();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    applePay = _useState2[0],
    setApplePay = _useState2[1];
  useEffect(function () {
    var applePay = recurly.ApplePay({
      country: MERCHANT_COUNTRY,
      currency: priceSummary === null || priceSummary === void 0 ? void 0 : priceSummary.currency,
      label: 'Chegg, Inc.',
      total: "".concat(priceSummary === null || priceSummary === void 0 ? void 0 : priceSummary.total),
      braintree: {
        clientAuthorization: clientAuthorization
      }
    });
    setApplePay(applePay);
  }, [priceSummary === null || priceSummary === void 0 ? void 0 : priceSummary.total, priceSummary === null || priceSummary === void 0 ? void 0 : priceSummary.currency, clientAuthorization]);
  useEffect(function () {
    var handleApplePayError = function handleApplePayError(error) {
      if (error.code !== 'apple-pay-not-supported') {
        sendNewRelicMessage('Recurly Apple Pay Service error', {
          errors: "".concat(JSON.stringify(error)),
          vendorType: VendorType.RECURLY
        });
        dispatch(createMOPError({
          message: {
            text: mopGeneric.message_detail,
            type: StatusTypes.ERROR,
            code: mopGeneric.message_id
          }
        }));
        doFireStatusUpdate([{
          status: StatusTypes.ERROR,
          command: PaymentMethodsCommandNames.FETCH_PAYMENT_METHOD,
          payload: {
            component: Component.RECURLY_SERVICE,
            errors: [ERRORS.PAYMENT_PROCESSING_ERROR]
          }
        }]);
      }
    };
    applePay === null || applePay === void 0 || applePay.on('token', function (_ref2) {
      var id = _ref2.id;
      void handlePaymentAuthorized(id, isPrimary, country);
    });
    applePay === null || applePay === void 0 || applePay.ready(function () {
      var applyPayButton = document.getElementById(applePayButtonId);
      /* istanbul ignore next */
      if (applyPayButton) {
        applyPayButton.onclick = function () {
          applePay.begin();
          sendRioEvent({
            info: getString('APP.RIO.EVENTS.EL_NAME.APPLE_PAY_BUTTON_CLICKED'),
            specType: SpecType.INTERACTION,
            subType: SubType.CLICK,
            elementType: ElementType.BUTTON,
            callback: sendRioEventCallback,
            namespace: rioNamespace
          });
        };
      }
    });
    applePay === null || applePay === void 0 || applePay.on('error', handleApplePayError);
    return function () {
      applePay === null || applePay === void 0 || applePay.off('error', handleApplePayError);
    };
  }, [applePay, rioNamespace, country, isPrimary, handlePaymentAuthorized]);
  return applePayButtonId;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/business/processors/recurly/ApplePayService.js
// module id = 4630
// module chunks = 11